import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import welcomeImage1 from '../src/Assets/welcome1.jpg';
import welcomeImage2 from '../src/Assets/welcome2.jpg';
import RoomImage1 from '../src/Assets/Room 1.jpeg';
import RoomImage2 from '../src/Assets/Room 2.jpeg';
import RoofTopImage from '../src/Assets/roof-top.png';
import logo from '../src/Assets/logo_ Mistwood_Manor.jpeg';

// // ============ Header Component ============
// const Header = () => {
//   const [menuOpen, setMenuOpen] = useState(false);

//   return (
//     <header className="header sticky-top">
//       <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
//         <div className="container-fluid px-4 px-lg-5">
//           <a className="navbar-brand fw-bold fs-4 text-dark" href="#home">
//             <span className="luxury-icon"></span>  Mistwood Manor
//           </a>
//           <button
//             className="navbar-toggler border-0"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarNav"
//             aria-controls="navbarNav"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>
//           <div className="collapse navbar-collapse" id="navbarNav">
//             <ul className="navbar-nav ms-auto gap-3">
//               <li className="nav-item dropdown">
//                 <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
//                   Home
//                 </a>
//                 <ul className="dropdown-menu">
//                   <li><a className="dropdown-item" href="#hero">Hero Section</a></li>
//                   <li><a className="dropdown-item" href="#welcome">Welcome</a></li>
//                 </ul>
//               </li>
//               <li className="nav-item dropdown">
//                 <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
//                   Rooms
//                 </a>
//                 <ul className="dropdown-menu">
//                   <li><a className="dropdown-item" href="#rooms">All Rooms</a></li>
//                   <li><a className="dropdown-item" href="#rooms">Suites</a></li>
//                 </ul>
//               </li>
//               {/* <li className="nav-item dropdown">
//                 <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
//                   Pages
//                 </a>
//                 <ul className="dropdown-menu">
//                   <li><a className="dropdown-item" href="#facilities">Facilities</a></li>
//                   <li><a className="dropdown-item" href="#testimonials">Testimonials</a></li>
//                 </ul>
//               </li> */}
//               {/* <li className="nav-item">
//                 <a className="nav-link" href="#blog">Blog</a>
//               </li> */}
//               <li className="nav-item">
//                 <a className="nav-link" href="#rooms">Contact</a>
//               </li>
//             </ul>
//             <a href='#rooms' className="btn btn-gold ms-3 rounded-pill">Reservation</a>
//           </div>
//         </div>
//       </nav>
//     </header>
//   );
// };

// ============ Header Component ============
const Header = ({ logoSrc = logo, logoAlt = "Mistwood Manor Logo" }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header sticky-top">
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
        <div className="container-fluid px-4 px-lg-5">
          <a className="navbar-brand fw-bold fs-4 text-dark d-flex align-items-center" href="#home">
            {logoSrc ? (
              <img 
                src={logoSrc} 
                alt={logoAlt}
                className="header-logo me-2"
              />
            ) : (
              <span className="luxury-icon me-2">✦</span>
            )}
            Mistwood Manor
          </a>
          <button
            className="navbar-toggler border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto gap-3">
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
                  Home
                </a>
                <ul className="dropdown-menu">
                  <li><a className="dropdown-item" href="#hero">Hero Section</a></li>
                  <li><a className="dropdown-item" href="#welcome">Welcome</a></li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
                  Rooms
                </a>
                <ul className="dropdown-menu">
                  <li><a className="dropdown-item" href="#rooms">All Rooms</a></li>
                  <li><a className="dropdown-item" href="#rooms">Suites</a></li>
                </ul>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#rooms">Contact</a>
              </li>
            </ul>
            <a href='#rooms' className="btn btn-gold ms-3 rounded-pill">Reservation</a>
          </div>
        </div>
      </nav>
    </header>
  );
};

// ============ Hero Component ============
const Hero = () => {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-background">
        <div className="hero-overlay"></div>
        <div className="container-fluid h-100 d-flex align-items-center">
          <div className="row w-100 align-items-center">
            <div className="col-lg-6 col-md-8 text-white hero-content">
              <h1 className="display-3 fw-bold mb-4 hero-title">
                Where Comfort Meets <br />Timeless Elegance
              </h1>
              <p className="lead mb-5 hero-text">
                Experience a place where elegance meets genuine comfort and service is always attentive. 
                We take pride in every detail, creating a peaceful, refined atmosphere designed to make every stay unforgettable.
              </p>
              <button className="btn btn-gold btn-lg rounded-pill">
                Reserve Your Stay
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// ============ Welcome Component ============
const Welcome = () => {
  return (
    <section id="welcome" className="welcome-section py-5">
      <div className="container py-4">
        <div className="row align-items-center gap-4">
          <div className="col-lg-5">
            <div className="welcome-images">
              <img 
                src={welcomeImage1}
                alt="Luxury bedroom" 
                className="img-fluid rounded-4 mb-3 d-block"
              />
              <img 
                src={welcomeImage2}
                alt="Fine dining" 
                className="img-fluid rounded-4 d-block"
              />
            </div>
          </div>
          <div className="col-lg-6">
            <span className="badge-gold">Welcome</span>
            <h2 className="display-5 fw-bold mt-3 mb-4">
              Experience Comfort, Elegance and Exceptional Hospitality
            </h2>
            <p className="text-muted fs-5 mb-4">
              Welcome to our hotel, where comfort meets refined elegance in a setting designed for relaxation and unforgettable stays. Located in a prime destination, our property offers thoughtfully designed rooms, modern amenities, and warm hospitality tailored to every traveler. From peaceful mornings to restful nights, every detail is carefully crafted to ensure your stay is seamless, comfortable, and truly memorable.
            </p>
            <button className="btn btn-gold rounded-pill">Explore Our Rooms</button>
          </div>
        </div>
      </div>
    </section>
  );
};

// ============ Contact Modal Component ============
const ContactModal = ({ isOpen, onClose, roomName, roomImages, currentImageIndex }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    checkInDate: '',
    checkOutDate: '',
    guests: '',
    roomRequirements: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [imageIndex, setImageIndex] = useState(currentImageIndex || 0);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const nextImage = () => {
    setImageIndex((prev) => (prev + 1) % roomImages.length);
  };

  const prevImage = () => {
    setImageIndex((prev) => (prev - 1 + roomImages.length) % roomImages.length);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Replace this with your Google Apps Script URL
      const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxt5VURwzrS3LDRJfgQHTG2AQnXgrmSXv4NOBFpkB2bTukpE8Ap0M1KowgRxiyDOIsEww/exec';
      
      const response = await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          room: roomName,
          ...formData
        })
      });

      setSubmitMessage('Thank you! We will contact you soon with pricing information.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        checkInDate: '',
        checkOutDate: '',
        guests: '',
        roomRequirements: ''
      });
      
      setTimeout(() => {
        onClose();
        setSubmitMessage('');
      }, 2000);
    } catch (error) {
      setSubmitMessage('Error submitting form. Please try again.');
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-content-large" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>&times;</button>
        <div className="modal-body-with-image">
          <div className="modal-image-section">
            <div className="modal-image-wrapper position-relative">
              <img 
                src={roomImages[imageIndex]} 
                alt={roomName} 
                className="modal-room-image"
              />
              {roomImages.length > 1 && (
                <>
                  <button 
                    className="btn btn-sm btn-light position-absolute top-50 start-0 translate-middle-y ms-2" 
                    onClick={prevImage}
                  >
                    ❮
                  </button>
                  <button 
                    className="btn btn-sm btn-light position-absolute top-50 end-0 translate-middle-y me-2" 
                    onClick={nextImage}
                  >
                    ❯
                  </button>
                  <div className="position-absolute bottom-0 start-50 translate-middle-x mb-3">
                    <span style={{
                      background: 'rgba(0, 0, 0, 0.6)',
                      color: 'white',
                      padding: '0.5rem 1rem',
                      borderRadius: '50px',
                      fontSize: '0.85rem',
                      fontWeight: '600',
                      backdropFilter: 'blur(10px)'
                    }}>
                      {imageIndex + 1} / {roomImages.length}
                    </span>
                  </div>
                </>
              )}
            </div>
            <div className="modal-room-info">
              <h4 className="fw-bold">{roomName}</h4>
              {/* <p className="text-muted small">Click to view room details</p> */}
            </div>
          </div>
          <div className="modal-form-section">
            <h3 className="modal-title mb-4">Get Pricing</h3>
            {submitMessage ? (
              <div className="alert-message">{submitMessage}</div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Full Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Phone Number *</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Check-in Date *</label>
                    <input
                      type="date"
                      name="checkInDate"
                      value={formData.checkInDate}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Check-out Date *</label>
                    <input
                      type="date"
                      name="checkOutDate"
                      value={formData.checkOutDate}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Number of Guests *</label>
                  <select
                    name="guests"
                    value={formData.guests}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select...</option>
                    <option value="1">1 Guest</option>
                    <option value="2">2 Guests</option>
                    <option value="3">3 Guests</option>
                    <option value="4">4 Guests</option>
                    <option value="5+">5+ Guests</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Room Requirements / Special Requests</label>
                  <textarea
                    name="roomRequirements"
                    value={formData.roomRequirements}
                    onChange={handleChange}
                    placeholder="e.g., High floor, Ocean view, Accessible room, etc."
                    rows="3"
                  />
                </div>
                <button type="submit" className="btn btn-submit" disabled={isSubmitting}>
                  {isSubmitting ? 'Sending...' : 'Send Inquiry'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// ============ RoomCard Component ============
const RoomCard = ({ room }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % room.images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + room.images.length) % room.images.length);
  };

  return (
    <>
      <div className="room-card">
        <div className="room-image-wrapper position-relative">
          <img src={room.images[currentImageIndex]} alt={room.name} className="img-fluid rounded-3" />
          {room.badge && (
            <span className="badge-best-seller position-absolute top-0 start-0 m-3">
              {room.badge}
            </span>
          )}
          {room.images.length > 1 && (
            <>
              <button className="btn btn-sm btn-light position-absolute top-50 start-0 translate-middle-y ms-2" onClick={prevImage}>
                ❮
              </button>
              <button className="btn btn-sm btn-light position-absolute top-50 end-0 translate-middle-y me-2" onClick={nextImage}>
                ❯
              </button>
              <div className="position-absolute bottom-0 start-50 translate-middle-x mb-3">
                <span style={{
                  background: 'rgba(0, 0, 0, 0.6)',
                  color: 'white',
                  padding: '0.5rem 1rem',
                  borderRadius: '50px',
                  fontSize: '0.85rem',
                  fontWeight: '600',
                  backdropFilter: 'blur(10px)'
                }}>
                  {currentImageIndex + 1} / {room.images.length}
                </span>
              </div>
            </>
          )}
        </div>
        <div className="room-details mt-4">
          <div className="d-flex justify-content-between align-items-start mb-3">
            <div>
              <h5 className="fw-bold mb-2">{room.name}</h5>
              <div className="room-specs text-muted small">
                <span className="me-3">👥 {room.guests} Guests</span>
                <span>📏 {room.size} Feet Size</span>
              </div>
            </div>
          </div>
          <button 
            className="btn btn-gold w-50 rounded-pill mt-3"
            onClick={() => setIsModalOpen(true)}
          >
            Contact Us for Price
          </button>
        </div>
      </div>
      <ContactModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        roomName={room.name}
        roomImages={room.images}
        currentImageIndex={currentImageIndex}
      />
    </>
  );
};

// ============ Rooms Component ============
const Rooms = () => {
  const rooms = [
    {
      id: 1,
      name: 'Super Deluxe Room',
      price: 100,
      guests: 2,
      size: 28,
      images: [
        RoomImage1,
        RoomImage2,
      ],
      badge: null
    },
    
    
  ];

  return (
    <section id="rooms" className="rooms-section py-5">
      <div className="container py-4">
        <div className="text-center mb-5">
          <span className="badge-gold">Enjoy Your Stay</span>
          <h2 className="display-5 fw-bold mt-3 mb-3">Explore Rooms</h2>
          <p className="text-muted fs-5">
            Discover a curated selection of elegant rooms designed for comfort. From cozy spaces to refined suites, 
            every detail is crafted for a relaxing stay.
          </p>
        </div>
        <div className="row g-4 justify-content-center">
          {rooms.map((room) => (
            <div key={room.id} className="col-lg-6 col-md-10">
              <RoomCard room={room} />
            </div>
          ))}
        </div>
        {/* <div className="text-center mt-5">
          <button className="btn btn-gold btn-lg rounded-pill">View More Rooms</button>
        </div> */}
      </div>
    </section>
  );
};

// ============ Testimonials Component ============
const Testimonials = () => {
  return (
    <section className="testimonials-section py-5" style={{ background: 'linear-gradient(135deg, #8b7355 0%, #9d8367 100%)' }}>
      <div className="container py-4">
        <div className="row align-items-center gap-4">
          <div className="col-lg-4 text-center text-white">
            <h1 className="display-2 fw-bold mb-3">4.9</h1>
            <div className="mb-3">
              <span className="text-gold fs-5">★★★★★</span>
            </div>
            <p className="text-white-50">(300+ Reviews)</p>
          </div>
          <div className="col-lg-7 text-white">
            <div className="mb-4">
              <p className="fs-5 mb-3">
                Exceptional hospitality and comfort. The perfect choice for a relaxing and refreshing getaway.
              </p>
              <p className="text-white-50">Neeraj Garg</p>
            </div>
            {/* <div className="dots">
              <span className="dot text-gold me-2">●</span>
              <span className="dot text-white-50 me-2">●</span>
              <span className="dot text-white-50">●</span>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

// ============ Facilities Component ============
const Facilities = () => {
  return (
    <section id="facilities" className="facilities-section py-5">
      <div className="container py-4">
        <div className="text-center mb-5">
          <span className="badge-gold">Welcome to Mistwood Manor</span>
          <h2 className="display-5 fw-bold mt-3 mb-3">Hotel Facilities</h2>
          <p className="text-muted fs-5">
            From premium rooms to full-service amenities, our team ensures a comfortable and memorable 
            stay from check-in to check-out.
          </p>
        </div>

        <div className="row g-5 mb-5">
          <div className="col-lg-6">
            <img 
              src="https://i.pinimg.com/1200x/d4/bb/78/d4bb787d6c77661afbbb7376603cbbfb.jpg" 
              alt="Hotel facilities" 
              className="img-fluid rounded-4"
            />
          </div>
          <div className="col-lg-6">
            <div className="row g-4">
              <div className="col-md-6">
                <div className="facility-card facility-card-hover">
                  <div className="facility-image-wrapper">
                    <img 
                      src="https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=300&h=300&fit=crop" 
                      alt="Luxury Rooms" 
                      className="facility-image"
                    />
                  </div>
                  <div className="facility-content">
                    <div className="facility-number">🛏️</div>
                    <p className="text-muted small mt-2">COMFORT</p>
                    <p className="text-muted">Clean and Luxury Rooms</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="facility-card facility-card-hover">
                  <div className="facility-image-wrapper">
                    <img 
                      src="https://i.pinimg.com/1200x/e9/cb/3c/e9cb3c3885d5dd725e68a9347057ceb7.jpg" 
                      alt="Bonfire" 
                      className="facility-image"
                    />
                  </div>
                  <div className="facility-content">
                    <div className="facility-number">🔥</div>
                    <p className="text-muted small mt-2">OUTDOOR</p>
                    <p className="text-muted">Bonfire</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="facility-card facility-card-hover">
                  <div className="facility-image-wrapper">
                    <img 
                      src="https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=300&h=300&fit=crop" 
                      alt="Live Music" 
                      className="facility-image"
                    />
                  </div>
                  <div className="facility-content">
                    <div className="facility-number">🎵</div>
                    <p className="text-muted small mt-2">Entertainment</p>
                    <p className="text-muted">Live Music</p>
                  </div> 
                </div>    
              </div>

              <div className="col-md-6">
                <div className="facility-card facility-card-hover">
                  <div className="facility-image-wrapper">
                    <img 
                      src={RoofTopImage}
                      alt="Roof Top Restaurant" 
                      className="facility-image"
                    />
                  </div>
                 <div className="facility-content">
                    <div className="facility-number">🍽️</div>
                    <p className="text-muted small mt-2">Roof Top Restaurant</p>
                    <p className="text-muted">Delicious cuisine with a view</p>
                </div>
                </div>    
              </div>


               
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// ============ Offers Component ============
const Offers = () => {
  const deals = [
    {
      id: 1,
      title: 'Romantic Stay',
      subtitle: 'Romantic Getaway for Couples',
      badge: 'Best Seller',
      image: RoomImage1
    },
    {
      id: 2,
      title: 'Early Bird Deal',
      subtitle: 'Book Early & Save More',
      badge: 'Deal',
      image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=500&h=400&fit=crop'
    },
    {
      id: 3,
      title: 'Family Getaway',
      subtitle: 'Perfect for Family Vacations',
      badge: 'SPECIAL',
      image: 'https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=500&h=400&fit=crop'
    }
  ];

  return (
    <section className="offers-section py-5">
      <div className="container py-4">
        <div className="text-center mb-5">
          <span className="badge-gold">Exclusive Deals</span>
          <h2 className="display-5 fw-bold mt-3 mb-3">Latest Hotel Offers</h2>
        </div>
        <div className="row g-4">
          {deals.map((deal) => (
            <div key={deal.id} className="col-lg-4 col-md-6">
              <div className="offer-card position-relative overflow-hidden rounded-4">
                <img src={deal.image} alt={deal.title} className="img-fluid h-100 offer-img" />
                <div className="offer-overlay d-flex flex-column justify-content-between p-4">
                  <div>
                    <span className="badge-discount">{deal.badge}</span>
                  </div>
                  <div className="text-white">
                    <h5 className="fw-bold mb-2">{deal.title}</h5>
                    <p className="small">{deal.subtitle}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ============ FAQ Component ============
const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What time is check-in and check-out?',
      answer: 'Check-in is available from 2:00 PM and check-out is at 11:00 AM. Early check-in and late check-out may be available upon request.'
    },
    // {
    //   question: 'Do you offer airport pick-up or shuttle service?',
    //   answer: 'Yes, we offer airport pick-up and shuttle services. Please contact our concierge to arrange this service in advance.'
    // },
    {
      question: 'Are pets allowed in the hotel?',
      answer: 'We are a pet-friendly hotel. Pets are welcome with a small additional fee. Please inform us during booking.'
    },
    {
      question: 'Do you have free Wi-Fi?',
      answer: 'Yes, complimentary high-speed Wi-Fi is available throughout the hotel for all guests.'
    },
    {
      question: 'What facilities are available for guests?',
      answer: 'We offer a fitness center, spa, fine dining restaurant, conference facilities, and a 24-hour business center.'
    }
  ];

  return (
    <section className="faq-section py-5 bg-light">
      <div className="container py-4">
        <div className="row">
          <div className="col-lg-5 mb-4">
            <span className="badge-gold">FAQ</span>
            <h2 className="display-5 fw-bold mt-3">Everything You Need to Know About Staying With Us</h2>
          </div>
          <div className="col-lg-7">
            <div className="accordion" id="faqAccordion">
              {faqs.map((faq, index) => (
                <div key={index} className="accordion-item border-0 mb-3">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      onClick={() => setOpenIndex(openIndex === index ? null : index)}
                      style={{
                        backgroundColor: openIndex === index ? '#f8f9fa' : 'white',
                        color: '#000'
                      }}
                    >
                      {faq.question}
                    </button>
                  </h2>
                  <div
                    className="accordion-collapse collapse"
                    style={{
                      display: openIndex === index ? 'block' : 'none'
                    }}
                  >
                    <div className="accordion-body">
                      {faq.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// ============ Footer Component ============
const Footer = ({ logoSrc = logo, logoAlt = "Mistwood Manor Logo" }) => {
  return (
    <footer className="footer-section bg-dark text-white py-5">
      <div className="container py-4">
        <div className="row g-5 mb-5">
          <div className="col-lg-3">
            <h5 className="fw-bold mb-4">
              {logoSrc ? (
                <img 
                  src={logoSrc} 
                  alt={logoAlt}
                  className="footer-logo"
                  style={{
                    height: '40px',
                    width: 'auto',
                    marginRight: '0.5rem',
                    display: 'inline-block',
                    verticalAlign: 'middle'
                  }}
                />
              ) : (
                <span className="luxury-icon">✦</span>
              )}
              <span style={{ verticalAlign: 'middle' }}>Mistwood Manor Hotel</span>
            </h5>
            <p className="text-white-50 small">
              Experience luxury and comfort in our elegant hotel designed for your perfect stay.
            </p>
          </div>
          <div className="col-lg-3">
            <h6 className="fw-bold mb-4">Quick Links</h6>
            <ul className="list-unstyled">
              <li className="mb-2"><a href="#rooms" className="text-white-50 text-decoration-none">Rooms</a></li>
              <li className="mb-2"><a href="#facilities" className="text-white-50 text-decoration-none">Facilities</a></li>
              <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none">Dining</a></li>
            </ul>
          </div>
          <div className="col-lg-3">
            <h6 className="fw-bold mb-4">Support</h6>
            <ul className="list-unstyled">
              <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none">Contact Us</a></li>
              <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none">Reservations</a></li>
              <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none">Privacy Policy</a></li>
              <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none">Terms & Conditions</a></li>
            </ul>
          </div>
          <div className="col-lg-3">
            <h6 className="fw-bold mb-4">Contact</h6>
            <p className="text-white-50 small mb-2">📍 Herendale Estate, Buddha Temple road, Happy Valley, Mussoorie, Uttarakhand, 248179</p>
            <p className="text-white-50 small mb-2">📞 +91 8860904811</p>
            <p className="text-white-50 small">📧 info@mistwoodmanor.com</p>
            <p className="text-white-50 small">📧 reservation@mistwoodmanor.com</p>
          </div>
        </div>
        <hr className="border-white-50" />
        <div className="text-center text-white-50 small">
          <p>&copy; 2026 Mistwood Manor. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

// ============ Main App Component ============
export default function App() {
  return (
    <div className="app">
      <Header />
      <Hero />
      <Welcome />
      <Rooms />
      <Testimonials />
      <Facilities />
      {/* <Offers /> */}
      <FAQ />
      <Footer />
    </div>
  );
}
